import React from "react";

export const exportExcel = async (data: any) => {
  import("xlsx").then((xlsx) => {
    const parseData = data.map((item: any) => {
      return {
        Name: item.vulnerabiliteName,
      };
    });

    const worksheet = xlsx.utils.json_to_sheet(parseData);
    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Vulnerability");

    /* calculate column width */
    worksheet["!cols"] = Object.keys(parseData[0]).map((ele) => ({
      wch: 30,
    }));

    xlsx.writeFile(workbook, "Vulnerability.xlsx", { compression: true });
  });
};
